// ##### Storyboards

import sb001 from './storyboard/elsbeth_4.jpg';
import sb002 from './storyboard/elsbeth_5.jpg';
import sb003 from './storyboard/elsbeth_107_Scene_9.jpg';
import sb004 from './storyboard/elsbeth_107_Scene_21.jpg';
import sb005 from './storyboard/Evil_409_022_01.jpg';
import sb006 from './storyboard/Evil_409_043_02.jpg';
import sb008 from './storyboard/Evil_409_043_04.jpg';
import sb009 from './storyboard/Evil_409_043_02.jpg';
import sb010 from './storyboard/en_page5_D&R.jpg';
import sb011 from './storyboard/en_page6_D&R.jpg';
import sb012 from './storyboard/Evil_403_009_03.jpg';
import sb013 from './storyboard/Evil_403_037_06.jpg';
import sb014 from './storyboard/pDTp2.jpg';

import evilTitle from './storyboard/title_evil.jpg';
import elsbethTitle from './storyboard/title_elsbeth.jpg';
import dieselTitle from './storyboard/title_diesel.jpg';
import tdtTitle from './storyboard/title_dt.jpg';

// ##### Illustrations

import ill001 from './illustration/com01.webp';
import ill002 from './illustration/com02.webp';
import ill003 from './illustration/com03.webp';
import ill004 from './illustration/com04.webp';
import ill005 from './illustration/com05.webp';
import ill006 from './illustration/com06.webp';
import ill007 from './illustration/com07.webp';
import ill008 from './illustration/DF01.webp';
import ill009 from './illustration/DF02.webp';
import ill010 from './illustration/lils01.webp';
import ill011 from './illustration/lils02.webp';
import ill012 from './illustration/lils03.webp';
import ill013 from './illustration/lils04.webp';
import ill014 from './illustration/misc008.webp';
import ill015 from './illustration/misc009.webp';
import ill016 from './illustration/misc010.webp';
import ill017 from './illustration/papa00.webp';
import ill018 from './illustration/papa001.webp';
import ill019 from './illustration/posters01.webp';
import ill020 from './illustration/posters02.webp';
import ill021 from './illustration/posters03.webp';
import ill022 from './illustration/posters04.webp';
import ill023 from './illustration/studies01.webp';
import ill024 from './illustration/studies02.webp';

// ##### Pixel art

import paghostfloat from './pixelart/ghostfloat.gif'
import paimp from './pixelart/imp.gif'
import paorcwalk from './pixelart/orcwalk.gif'
import pastafffloat from './pixelart/stafffloat.gif'
import paserpent from './pixelart/Sea Serpent Swim.gif'
import beebottalk from './pixelart/beebot_talk_sheet.gif'
import beebotsleep from './pixelart/beebot_sleep_sheet.gif'
import beebotspin from './pixelart/beebot_loading_sheet.gif'

import pbgbeeday from './pixelart/Backdrop_cityscape_day.png'
import pbgbeedawn from './pixelart/Backdrop_cityscape_dawn.png'
import pbgbeedusk from './pixelart/Backdrop_cityscape_dusk.png'
import pbgbeenight from './pixelart/Backdrop_cityscape_night.png'

 export const illustrations = [ill001, ill002, ill003, ill004, ill005, ill006, ill007, ill008, ill009, ill010, ill011, ill012, ill013, ill014, ill015, ill016, ill017, ill018, ill019, ill020, ill021, ill022, ill023, ill024]

// ##### collect boards into groups by project & scene

const elsbeth = { 
    title: 'elsbeth',
    titleCard: elsbethTitle,
    images: [sb001, sb002, sb003, sb004] 
}
const evil = { 
    title: 'evil',
    titleCard: evilTitle,
    images: [sb005, sb006, sb008, sb009, sb012, sb013] 
}
const dieselAndRust = { 
    title: 'diesel-and-rust',
    titleCard: dieselTitle ,
    images: [sb010, sb011] 
}
const darkTower = { 
    title: 'dark-tower',
    titleCard: tdtTitle,
    images: [sb014] 
}

// #### export

export const storyboards = [evil, dieselAndRust, elsbeth, darkTower]

export const pixels  = [[paserpent], [paghostfloat, paimp, paorcwalk, pastafffloat], [beebotsleep, beebotspin, beebottalk], [pbgbeeday, pbgbeedawn, pbgbeedusk, pbgbeenight]]